export default __webpack_public_path__ + "img/bNnhgVOY.d14cbb9b.svg";